export default __webpack_public_path__ + "ffd2493280c464aa903f2c9375e76144.png";